import PropTypes from "prop-types";
import React from "react";
// @mui
import { Box, styled, Typography } from "@mui/material";

// ----------------------------------------------------------------------

const RootStyle = styled(({ ...props }) => ( <Box { ...props } /> ))(({ theme, variant }) => ( {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,

    width: "fit-content",
    minHeight: "18px",

    paddingRight: "6px",
    paddingLeft: "6px",

    // eslint-disable-next-line no-nested-ternary
    backgroundColor: variant === "alert" ? theme.palette.error.main :
        // eslint-disable-next-line no-nested-ternary
        variant === "info" ? theme.palette.info.main :
            // eslint-disable-next-line no-nested-ternary
            variant === "success" ? theme.palette.success.main :
                // eslint-disable-next-line no-nested-ternary
                variant === "warning" ? theme.palette.warning.main :
                    variant === "primary" ? theme.palette.text.primary :
                        "inherit",

    borderRadius: "8px",
    overflow: "hidden"
} ));

// ----------------------------------------------------------------------

XTag.propTypes = {
    variant: PropTypes.string.isRequired,
    text: PropTypes.string,
    typographyProps: PropTypes.object
};

export default function XTag({ variant, text, typographyProps, ...other }) {
    return (
        <RootStyle variant={ variant } { ...other }>
            <Typography variant="caption" color="text.altered" noWrap { ...typographyProps }>
                { text }
            </Typography>
        </RootStyle>
    );
}
